/**
 * Created by trevor on 2015-03-19.
 */

function LatestPosts() {
    this.extends = [_ResponsiveTitles, _RSS];
    this.Formatters = this.Formatters ? this.Formatters : Formatters;
    this.node = null;
    this.id = null;
    this.declaredClass = null;

    this.init = function() {
        $(this.node).show();
        this.getRSS('/rss', $.proxy(this._onLoadRSS, this));
        this.registerResponsiveFunction($.proxy(this.resize, this, "mobile"), 0, window.mogo.registry.mogoUI.config.mediaQueries.small);
        this.registerResponsiveFunction($.proxy(this.resize, this, "tablet"), mogo.registry.mogoUI.config.mediaQueries.small + 1, mogo.registry.mogoUI.config.mediaQueries.medium);
        this.registerResponsiveFunction($.proxy(this.resize, this, "desktop"), mogo.registry.mogoUI.config.mediaQueries.medium + 1, null);
    };

    this.initAllReady = function() {};

    this._onLoadRSS = function() {
        var removeLoader = $.proxy(this.removeLoader, this);
        var posts = this.getLatestPosts(5);

        this.setLatestPostData(posts, function(){
            removeLoader();
        });
    };


    this.getLatestPosts = function(count) {
        var item = $(mogo.registry.mogoUI.blogRSS).find("item");
        var result = [];

        item.each(function(){
            if (result.length < count) {
                result.push($(this).context);
            } else {
                return false;
            }
        });

        return result;
    };

    this.setLatestPostData = function(posts, callback) {
        var node = this;
        var postList = $(this.node).find('ul');

        if (posts.length > 0) {

            $(posts).each(function () {
                var title = $(this).find("title").text();
                var date = $(this).find("pubDate").text();
                var link = $(this).find("link").text();
                var formattedDate = node.Formatters.formatDate(date);
                var postURI = node.parseURLtoURI(link);
                var post = node.lookupRSSbyURI(postURI);
                var category = node.getPostCategories(post);
                var img = node.getPostImage(post);

                postList.append('<li class="row"><a href="' + link + '"><div class="large-6 medium-12 columns thumb" style="background-image:url(' + img + ')"><div class="cat-meta ' + category + '-icon"></div></div></a><div class="large-6 medium-12 columns"><div class="date">' + formattedDate + '</div><div class="text"><a class="strong contentContainer" href="' + link + '">' + title + '</a></div></div></li>');
            });

            var thumbs = $(".thumb", this.node);
            for (var i = 0; i < thumbs.length; i++) {
                $(thumbs[i]).mogo().create("FeaturedImage", {});
            }

        } else {
            postList.append('<li class="row"><br/>No posts to show</li>');
        }

        callback();
    };
}
